<template>
  <div class="we-tabs">
    <div class="we-tabs__tabs">
      <ul @touchstart="onStart($event)">
        <li v-for="tab in tabs" :class="{ 'tab--active': tab.isActive }">
          <a :href="tab.href" @click="selectTab(tab)" v-bind="tab.$attrs">{{ tab.name }}</a>
        </li>
      </ul>
    </div>

    <div class="we-tabs__panels container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { 
      tabs: [],
      iMouseX: 0,
      elementTranslate: 0,
      limitLeft: 0,
      limitRight: 0,
      element: ''
    }
  },
  created() {
    this.tabs = this.$children
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name == selectedTab.name)
      })
    },
    onStart (event) {
      this.element = event.currentTarget
      this.iMouseX = event.touches[0].pageX
      this.elementTranslate = window.getComputedStyle(this.element).getPropertyValue("transform").match(/(-?[0-9\.]+)/g)
      this.limitRight = this.element.scrollWidth - this.element.offsetWidth;

      this.element.addEventListener('touchmove', this.onMove)
      this.element.addEventListener('touchend', this.onEnd)
    },
    onMove (moveEvent) {
      let moved = this.iMouseX - moveEvent.touches[0].clientX
      Math.sign(moved) === -1 ? moved = Math.abs(moved) : moved = (moved) * (-1)
      if (this.elementTranslate) {
        moved = Number(this.elementTranslate[4]) + moved
      }

      if (moved < -this.limitRight) {
        moved = -this.limitRight
      } else if (moved > this.limitLeft) {
        moved = this.limitLeft
      }
      this.element.style.transform = 'translateX(' + moved +'px)' 
    },
    onEnd (event) {
      this.element.removeEventListener('touchmove', this.onMove)
      this.element.removeEventListener('touchend', this.onEnd)
    }
  },
}
</script>